function accordion(element) {
  $(element).on('click', function() {
    const $this = $(this);
    const $accordion = $this.closest('.accordion');

    $accordion
      .toggleClass('active')
      .siblings()
      .removeClass('active')
      .find('.accordion__content')
      .slideUp();
    $accordion.find('.accordion__content').slideToggle();
  });
}

module.exports = {
  accordion
};
